var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }),
              _c(
                "b-col",
                {
                  staticClass: "my-1",
                  attrs: { cols: "12", md: "2", sm: "1" },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mb-2",
                  staticStyle: { position: "relative", "z-index": "1" },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      ":per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      items: _vm.filteredTimesheetList,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head(reference)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Reference")]),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search Reference",
                                      size: "sm",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.reference,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "reference", $$v)
                                      },
                                      expression: "filters.reference",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(date)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Date")]),
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      range: "",
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select date range",
                                      size: "sm",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.dateRange,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "dateRange", $$v)
                                      },
                                      expression: "filters.dateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(status)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Status")]),
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.timesheetStatus,
                                      placeholder: "Select Status",
                                      size: "sm",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "status", $$v)
                                      },
                                      expression: "filters.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(approvalDate)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Approval Date")]),
                                  _c("DatePicker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      range: "",
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select date range",
                                      size: "sm",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.currentPage = 1
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.approvalDateRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "approvalDateRange",
                                          $$v
                                        )
                                      },
                                      expression: "filters.approvalDateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(employeeID)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getEmployee(data.item.employeeID)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(approvalDate)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatDate(data.item.approvalDate)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    variant: "link",
                                    "toggle-class": "text-decoration-none",
                                    "no-caret": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle mr-25",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm.checkPermissions(data.item)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.timesheetAction(
                                                "APPROVED",
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "CheckIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("Approve")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.checkPermissions(data.item)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.timesheetAction(
                                                "REJECTED",
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "XIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("Reject")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to:
                                          "/jobcardtimesheet/view/" +
                                          data.item.id,
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "EyeIcon" },
                                      }),
                                      _c("span", [_vm._v("View")]),
                                    ],
                                    1
                                  ),
                                  data.item.status === "PENDING" &&
                                  data.item.approverID === _vm.userId
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to:
                                              "/jobcardtimesheet/edit/" +
                                              data.item.id,
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "Edit2Icon" },
                                          }),
                                          _c("span", [_vm._v("Update")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2886483452
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.timesheetList.length == 0
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "d-flex justify-content-center",
                              attrs: { variant: "warning", show: "" },
                            },
                            [
                              _c("h4", { staticClass: "alert-heading" }, [
                                _vm._v("No items found"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "mt-2",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }